import "./index.css";

import { CampagneCreator } from "@/components/CampagneCreator";
import { CampagneDetail } from "@/components/CampagneDetail";
import { CampagneList } from "@/components/CampagneList";
import { CampagneModifier } from "@/components/CampagneModifier";
import { ParcoursDetail } from "@/components/ParcoursDetail";
import { HorsCampagne } from "@/components/HorsCampagne";
import { MonOrganisation } from "@/routes/MonOrganisation";
import { Parametres } from "@/routes/Parametres";
import {
  ScorecardEdition,
  ScorecardHistorique,
  ScorecardsListe,
} from "@/routes/Scorecards";
import { NotFound, TooltipProvider } from "@repo/ui";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { AdminAuthGuard } from "./components/AdminAuthGuard";
import { RedirectionResultatEpreuve } from "./components/RedirectionResultatEpreuve";
import { LoginPage } from "@repo/auth";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage title="Portail Client" />,
  },
  {
    element: <AdminAuthGuard />,
    children: [
      {
        path: "/",
        element: <CampagneList />,
      },
      {
        path: "/p/:id",
        element: <ParcoursDetail />,
      },
      {
        // Ancienne page de résultat d'une épreuve : redirigée vers l'onglet de
        // l'épreuve dans la fiche, pour les liens déjà envoyés.
        path: "/p/:parcoursId/evaluation/:evaluationId",
        element: <RedirectionResultatEpreuve />,
      },
      {
        path: "/campagnes",
        element: <CampagneList />,
      },
      {
        path: "/campagnes/:id",
        element: <CampagneDetail />,
      },
      {
        path: "/campagnes/:id/modifier",
        element: <CampagneModifier />,
      },
      {
        path: "/campagnes/creer",
        element: <CampagneCreator />,
      },
      // Parcours sans campagne (§0.3) : `campagneId` est optionnel en base, ces
      // parcours seraient inatteignables sans cette route.
      {
        path: "/campagnes/hors-campagne",
        element: <HorsCampagne />,
      },
      {
        path: "/organisation",
        element: <MonOrganisation />,
      },
      {
        path: "/parametres",
        element: <Parametres />,
      },
      // Gestionnaires seulement (garde dans la page, droits côté Convex).
      {
        path: "/scorecards",
        element: <ScorecardsListe />,
      },
      {
        path: "/scorecards/:id",
        element: <ScorecardEdition />,
      },
      {
        path: "/scorecards/:id/historique",
        element: <ScorecardHistorique />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function App() {
  return (
    <TooltipProvider>
      <RouterProvider router={router} />
    </TooltipProvider>
  );
}

export default App;
